import { render, staticRenderFns } from "./ServiceLine.vue?vue&type=template&id=354b9545&scoped=true"
import script from "./ServiceLine.vue?vue&type=script&lang=ts"
export * from "./ServiceLine.vue?vue&type=script&lang=ts"
import style0 from "./ServiceLine.vue?vue&type=style&index=0&id=354b9545&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354b9545",
  null
  
)

export default component.exports